import React from 'react';

export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/+27714505692"
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-fab"
      aria-label="Chat with us on WhatsApp"
      title="Chat with us on WhatsApp"
    >
      💬
    </a>
  );
}
